import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import isUsingArtemisStyles from '../../v2/selectors/isUsingArtemisStyles';
import CheckIcon from './CheckIcon';
import useStyles from './SelectableContainer.styles';

export function SelectableContainer(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const Tag = props.onClick ? 'button' : 'div';
  
  const getCheckIcon = () => (
    <div className={classes.checkIconTopRight} aria-hidden>
      <CheckIcon monotoneCheck isArtemisIcon={props.isUsingArtemisStyles} />
    </div>
  );
  
  const getTabIcon = () => (
    <span className={classes.tabIcon}>
      {props.tabIcon}
    </span>
  );
  
  const getButtonIcon = () => (
    <span className={classes.buttonIcon}>
      {props.buttonIcon}
    </span>
  );
  
  const accessibilityProps = props.ariaPressedValue !== null ? {
    'aria-pressed': props.ariaPressedValue,
  } : {};
  
  return (
    <Tag
      className={classes.container}
      id={props.componentId && `SelectableContainer--${props.componentId}`}
      data-test={props.dataTestSuffix ? `SelectableContainer--${props.dataTestSuffix}` : 'SelectableContainer'}
      type={props.onClick ? 'button' : undefined}
      role={props.role}
      aria-selected={props.isSelected}
      onClick={props.onClick}
      {...accessibilityProps}
    >
      {props.tabIcon && getTabIcon()}
      {props.buttonIcon && getButtonIcon()}
      {!props.hideIcon && props.isSelected && getCheckIcon()}
      
      {props.children}
    </Tag>
  );
}

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

SelectableContainer.propTypes = {
  buttonIcon: PropTypes.node,
  componentId: PropTypes.string,
  ariaPressedValue: PropTypes.bool,
  isSelected: PropTypes.bool.isRequired,
  fullWidth: PropTypes.bool,
  children: PropTypes.node.isRequired,
  hideIcon: PropTypes.bool,
  onClick: PropTypes.func,
  role: PropTypes.string,
  styleAs: PropTypes.bool,
  tabIcon: PropTypes.node,
  noShadow: PropTypes.bool,
  noBoxShadow: PropTypes.bool,
  wrapContent: PropTypes.bool,
  dataTestSuffix: PropTypes.string,
  isUsingArtemisStyles: PropTypes.bool,
  noBorder: PropTypes.bool,
  alternativeBillingLayout: PropTypes.bool,
};

SelectableContainer.defaultProps = {
  ariaPressedValue: null,
  hideIcon: false,
};

export default connect(mapStateToProps)(SelectableContainer);
